import styled from 'styled-components';
import { StyledUiContainerProps } from 'components';
import styledTheme from 'common/theme';

export const SiteViewContainer = styled.div<StyledUiContainerProps>`
  gap: 1em;
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;

  @media (max-width: 1350px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 950px) {
    display: flex;
    flex-direction: column;
    grid-gap: 1em;
  }

  .site-map-widget .widget-ui__main {
    padding: 0px;
    display: flex;
  }
`;

export const MachineMapContainer = styled.div<{ height?: number }>`
  display: flex;
  height: ${(props) => (props.height ? `${props.height / 16}rem` : '15.625rem')};
  width: 80%;
`;

export const MapInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 20%;
  padding: 20px;

  .site-map-title {
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 15px;
    color: ${styledTheme.colors.darkBlack};
  }

  .site-map-information {
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 15px;
    color: ${styledTheme.colors.darkBlack};
  }
`;
